import { Skeleton, useValidationResultDialog } from '@nest/uikit-react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';

const OutboundDocumentTypeRow = ({ documentType, onClick }: { documentType: { id: number; name: string }; onClick: () => void }) => {
	const client = useTerminalClient();

	const countQuery = useQuery({
		queryKey: ['outbound-delivery-orders-count-by-document-type', documentType.id],
		queryFn: () => client.outboundDeliveryOrders.countOutboundDeliveryOrdersByDocumentTypeQuery.execute({ documentTypeId: documentType.id }),
		enabled: !!documentType.id
	});

	return (
		<button type="button" onClick={onClick} className="w-full rounded-md border bg-card px-3 py-3 text-left shadow-sm transition-colors hover:bg-muted/50 active:bg-muted">
			<div className="flex items-center justify-between gap-3">
				<span className="truncate text-base font-medium">{documentType.name}</span>

				{countQuery.isLoading ? (
					<Skeleton className="h-6 w-10 rounded-full" />
				) : (
					<span className="inline-flex h-6 shrink-0 items-center justify-center rounded-full border px-2 text-sm font-semibold">{countQuery.data ?? 0}</span>
				)}
			</div>
		</button>
	);
};

export default function OutboundPage() {
	const client = useTerminalClient();
	const navigate = useNavigate();

	const { data, error } = useQuery({
		queryKey: ['outbound-document-types'],
		queryFn: () => client.outboundDeliveryOrderDocumentTypes.getAllOutboundDeliveryOrderDocumentTypesForMeQuery.execute({})
	});

	useValidationResultDialog([error]);

	return (
		<TerminalScreen showBackButton backButtonTo="/" topBar={<div>Výdej</div>}>
			<div className="flex flex-col gap-2 p-2">
				{data ? (
					data.map(type => <OutboundDocumentTypeRow key={type.id} documentType={type} onClick={() => navigate(`/outbound/${type.id}/queues`)} />)
				) : (
					<>
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
					</>
				)}
			</div>
		</TerminalScreen>
	);
}
